import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-modulos-asignados',
  templateUrl: './modulos-asignados.component.html',
  styleUrls: ['./modulos-asignados.component.scss']
})
export class ModulosAsignadosComponent implements OnInit {
  @Input() stepId: number;
  @Input() iconAvailableList: any;

  constructor() { }

  ngOnInit(): void {
  }


}
